import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_465cb8tmws: FaireBrandEntity = {
  token: "b_465cb8tmws",
  type: "brand",
  name: "Dear Scarlett",
  avatarUrl:
    "https://cdn.faire.com/fastly/b9f566934092861a6c6221e70ddf49a5687446716b4c53cee2cec92eb49c6d00.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4d23da73725db24031235ab0dfbaa838d51444cbef0e3a094f03e2c554156421.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b9f566934092861a6c6221e70ddf49a5687446716b4c53cee2cec92eb49c6d00.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4d23da73725db24031235ab0dfbaa838d51444cbef0e3a094f03e2c554156421.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 259,
  isInsider: true,
  description:
    "Dear Scarlett was created with one clear purpose: to support our retail partners with dependable, proven styles that sell. In an ever-changing market, we believe our greatest value is consistency—delivering collections retailers can trust season after season.\n\nKnown for signature programs like our Wrinkle-Free Collection and the beloved Lizzy Collection, Dear Scarlett focuses on pieces that offer reliable sell-through while remaining easy for customers to wear and love. Our assortment ranges from tops and bottoms to coordinated sets and outerwear, all designed with comfort, versatility, and everyday style in mind.\n\nWe are also committed to offering competitive pricing within the market, ensuring our retailers can maintain strong margins while providing their customers with exceptional value.\n\nAt Dear Scarlett, we focus on developing stable, repeatable winners so our retail partners can confidently build their assortment around styles that consistently perform—time and time again.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:22.827Z",
    importedBy: "entity-db-cli",
  },
};
